import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Articles',
    href: '#articles'
  }, {
    name: 'Media',
    href: '#media'
  }, {
    name: 'Consulting',
    href: '#consulting'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Work History',
    href: '#work-history'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0B1120]/90 backdrop-blur-xl border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="flex justify-between items-center" data-id="element-179">
          <div className="flex-shrink-0 flex items-center" data-id="element-180">
            <a href="#hero" data-id="element-181">
              <span className={`font-semibold text-xl tracking-tight text-white`} data-id="element-182">
                Arthur Miller
              </span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8" data-id="element-183">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-300 hover:text-cyan-400 transition-colors" data-id="element-184">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-185">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-300 hover:text-white focus:outline-none" aria-label="Toggle menu" data-id="element-186">
              {isOpen ? <X className="h-6 w-6" data-id="element-187" /> : <Menu className="h-6 w-6" data-id="element-188" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden absolute top-full left-0 w-full bg-[#0B1120]/95 backdrop-blur-xl shadow-lg border-t border-white/10" data-id="element-189">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-190">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-300 hover:text-cyan-400 hover:bg-white/5 rounded-md" data-id="element-191">
                {link.name}
              </a>)}
          </div>
        </div>}
    </header>;
}